import axios from 'axios';
import apisUrls from '../urls';

const deleteDeviceBrandApi = (id) => {
  return axios.delete(`${apisUrls?.deleteDeviceBrand}?deviceBrand_id=${id}`);
};

export default deleteDeviceBrandApi;
